/* Load Modules */
import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {ValidConfigurationState} from "../../../../reducers/configFormValid.reducer";
import FormBoxes from "../../../../../../utils/forms/components/FormBoxes";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import Form from "../../../../../../utils/forms/components/Form";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../store/store";
import { SettingsConfiguration } from "../../../../reducers/editingConfiguration.reducer";

// Utils
//import { checkIfConditionMeet } from "../../../../../../utils/utils";

// Styles
import "./SettingsConfigurationSection.component.scss";

/* Load Forms */
import {
    settingsConfigBox,
    bingoConfigBox,
    spinsConfigBox,
    lottoConfigBox,
    kenoConfigBox,
    pointSystemConfigBox,
    panelsConfigBox
} from "./FormBuild/SettingsConfiguratinSection.forms";
import {
    defaultValues,
    bingoDefaultValues,
    spinsDefaultValues,
    pointSystemDefaultValues,
    panelsDefaultValues,
    lottoDefaultValues,
    kenoDefaultValues
} from "./FormBuild/SettingsConfiguratinSection.defaults";
import {
    regionPresetKeys,
    regionPresetSchema
} from "./FormBuild/SettingsConfiguratinSection.constants";

import { ConfigurationsActionTypes } from "../../../../actions/actionTypes";
import { subsidiaryDenominations } from "../../../../../../utils/addressUtils";
import { removeAccents } from "../../../../../../utils/utils";

export interface SettingsConfigurationSectionProps {
    updateSettingsConfig: ActionCreator;
    settingsConfig: SettingsConfiguration;
    settingsSchema: any;
    schemaLoading: boolean;
    basicConfig: any;
    editingConfigurationLoading: boolean;
    editingConfiguration: any;
    configSectionVisited: ActionCreator;
    updateGroupByGameType: ActionCreator;
    updateSpecialPrizesByBingoSettings: ActionCreator;
    gameInstances: any;
    gameGroups: any;
    selectedGameGroups: any;
    regions: any[];
    configFormValid: ValidConfigurationState;
}

export interface SettingsConfigurationSectionState {
    editingConfiguration: any;
}

const GAME_TYPES = {
    0: "Bingo",
    1: "Spins",
    2: "Lotto",
    3: "Keno"
};

class SettingsConfigurationSection extends Component<
    SettingsConfigurationSectionProps,
    SettingsConfigurationSectionState
> {
    constructor(props) {
        super(props);
        this.state = {
            editingConfiguration: this.props.editingConfiguration
        };
    }
    //remover alteração quando spins suportar pig boom e mr champion
    private previousSpinsFormValues = null;/*{
            values: { enable_pig_boom: false,  enable_mr_champion: false},
            isValid: true
        };*/
    private previousBingoFormValues = null;
    private previousMainFormValues = null;
    private previousPointSystemFormValues = null;
    private previousPanelsFormValues = null;
    private previousLottoFormValues = null;
    private previousKenoFormValues = null;

    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_SETTINGS_CONFIG
        );
    }

    onFormChange = formEvent => {
        //REMOVE OS GAME GROUPS DE TIPOS DE GAME TYPE QUE NÃO ESTÃO MAIS SELECIONADOS
        if (
            this.previousMainFormValues !== null &&
            this.previousMainFormValues.values.game_types.length !==
                formEvent.values.game_types.length
        ) {
            if (
                (this.props.gameGroups && this.props.gameGroups.length > 0) ||
                (this.props.editingConfiguration.settings.settings
                    .global_jackpot &&
                    this.props.editingConfiguration.settings.settings
                        .global_jackpot.length > 0)
            ) {
                if(this.props.editingConfiguration.settings.selectedGroupType === "game") {
                    // clone dos game groups
                    let newState = _.cloneDeep(this.props.gameGroups);
                    // clone dos game groups atribuidos aos bonus, povoada apenas depois de associar.. na primeira config ou para editar vem vazio
                    //{progressive: Array(0), mr_champion: Array(0), pig_boom: Array(0)}
                    let newStateSelected = _.cloneDeep(
                        this.props.selectedGameGroups
                    );
                    const gameInstances = this.props.gameInstances[
                        "results"
                        ].filter(instance => {
                        return (
                            formEvent.values.game_types.includes(GAME_TYPES[instance.game.type])
                        );
                    });

                    newState.map(gameGroup => {
                        let instancesToRemove = [];
                        gameGroup["game_instances"].map(instance => {
                            // verifica se o jogo que está no game group ainda pertence a selecão dos novos game types
                            if (
                                _.findIndex(gameInstances, gi => {
                                    return gi.identifier == instance;
                                }) == -1
                            ) {
                                instancesToRemove.push(instance);
                            }
                        });

                        gameGroup["game_instances"] = gameGroup[
                            "game_instances"
                            ].filter(instance => {
                            return !instancesToRemove.includes(instance);
                        });

                        if (gameGroup["game_instances"].length == 0) {
                            Object.keys(newStateSelected).map(selectedByType => {
                                newStateSelected[selectedByType] = newStateSelected[
                                    selectedByType
                                    ].filter(group => {
                                    return group.id !== gameGroup.id;
                                });
                            });
                        }

                        return gameGroup;
                    });

                    newState = newState.filter(gameGroup => {
                        return gameGroup["game_instances"].length > 0;
                    });

                    this.props.updateGroupByGameType({
                        newGroupsState: {
                            gameGroups: newState,
                            selected: newStateSelected}
                    });
                }
            }
        }

        let newFormValues = _.cloneDeep(formEvent.values);
        if (
            this.previousMainFormValues !== null &&
            formEvent.values.region !== null &&
            formEvent.values.region !== undefined
        ) {
            const selectedRegion = this.props.regions.find(
                region => region.id == formEvent.values.region
            );

            if (
                selectedRegion &&
                selectedRegion.presets[0].use_bank_and_reserve_in_auto == false
            ) {
                newFormValues.auto_mode_works_as_manual_mode = false;
            }
        }

        /*let isValid = formEvent.isValid;
        const values = { ...formEvent.values };
        if (checkIfConditionMeet(values, this.props.settingsSchema)) {
            // Then required is empty then change to not valid
            const conditionalRequired = this.props.settingsSchema["then"][
                "required"
            ];
            conditionalRequired.map(field => {
                if (
                    !values.hasOwnProperty(field) ||
                    values[field] == "" ||
                    values[field] == null ||
                    values[field] == undefined
                ) {
                    isValid = false;
                }
            });
        } else {
            const conditionalRequired = this.props.settingsSchema["then"][
                "required"
            ];
            conditionalRequired.map(field => {
                if (values.hasOwnProperty(field)) {
                    delete values[field];
                }
            });
            // Check if then -> clean
        }*/
        if(newFormValues.auto_session_enabled === "manual") newFormValues.auto_session_time = null
        this.previousMainFormValues = {
            values: { ...newFormValues },
            isValid: formEvent.isValid
        };
        this.updateStore(newFormValues);
    };

    onSpinsFormChange = formEvent => {
        this.previousSpinsFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore();
    };

    onBingoFormChange = formEvent => {
        let special_prizes = _.cloneDeep(this.props.editingConfiguration.settings.settings.special_prizes);
        let special_prizes_mr_champion = this.props.editingConfiguration.settings.settings.special_prizes.filter(sp=>sp.type=="mr_champion");
        let special_prizes_pig_boom = this.props.editingConfiguration.settings.settings.special_prizes.filter(sp=>sp.type=="pig_boom");
        let formValid = true;
        if (formEvent.values && formEvent.values.enable_mr_champion){
            if (special_prizes_mr_champion.length==0){
                formValid = false;
            }
        }else{
            special_prizes = special_prizes.filter(sp=>sp.type!="mr_champion")
        }
        if (formEvent.values && formEvent.values.enable_pig_boom){
            if (special_prizes_pig_boom.length==0){
                formValid = false;
            }
        }else{
            special_prizes = special_prizes.filter(sp=>sp.type!="pig_boom")
        }

        if(!this.props.configFormValid.specialPrizes){
            formValid = false
        }
        this.props.updateSpecialPrizesByBingoSettings({
            newPrizesState: special_prizes,
            actionToValidIDMap: formValid
        });
        this.previousBingoFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore();
    };

    onLottoFormChange = formEvent => {
        this.previousLottoFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore();
    };

    onKenoFormChange = formEvent => {
        this.previousKenoFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore();
    };

    onPointSystemFormChange = formEvent => {
        this.previousPointSystemFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore();
    };

    onPanelFormChange = formEvent => {
        this.previousPanelsFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore();
    };

    checkIfAllAreValid(point_system) {
        // point_system = "point_system" in values
        if (
            this.previousMainFormValues !== null &&
            this.previousMainFormValues.isValid
        ) {
            const isSpinsSelected =
                this.previousMainFormValues.values.game_types.indexOf(
                    "Spins"
                ) !== -1;
            const isBingoSelected =
                this.previousMainFormValues.values.game_types.indexOf(
                    "Bingo"
                ) !== -1;
            const isLottoSelected =
                this.previousMainFormValues.values.game_types.indexOf(
                    "Lotto"
                ) !== -1;
            const isKenoSelected =
                this.previousMainFormValues.values.game_types.indexOf(
                    "Keno"
                ) !== -1;
            const isPointsSystemSelected =
                this.previousMainFormValues.values.points_system;

            if (
                isSpinsSelected &&
                isBingoSelected &&
                isLottoSelected &&
                isKenoSelected &&
                this.previousSpinsFormValues !== null &&
                this.previousBingoFormValues !== null &&
                this.previousLottoFormValues !== null &&
                this.previousKenoFormValues !== null
            ) {
                if (point_system && isPointsSystemSelected && this.previousPointSystemFormValues !== null) {
                    return (
                        this.previousSpinsFormValues.isValid &&
                        this.previousBingoFormValues.isValid &&
                        this.previousLottoFormValues.isValid &&
                        this.previousKenoFormValues.isValid &&
                        this.previousPointSystemFormValues.isValid
                    );
                }else {
                    return (
                        this.previousSpinsFormValues.isValid &&
                        this.previousBingoFormValues.isValid &&
                        this.previousLottoFormValues.isValid &&
                        this.previousKenoFormValues.isValid
                    );
                }
            } else if (isSpinsSelected && !isBingoSelected && !isLottoSelected && !isKenoSelected && !point_system) {
                return true;
            } else if (
                isSpinsSelected &&
                this.previousSpinsFormValues !== null
            ) {
                if (point_system && isPointsSystemSelected && this.previousPointSystemFormValues !== null) {
                    return (
                        this.previousSpinsFormValues.isValid &&
                        this.previousPointSystemFormValues.isValid
                    );
                }else {
                    return this.previousSpinsFormValues.isValid;
                }
            } else if (
                isBingoSelected &&
                this.previousBingoFormValues !== null
            ) {
                if (point_system && isPointsSystemSelected && this.previousPointSystemFormValues !== null) {
                    return (
                        this.previousBingoFormValues.isValid &&
                        this.previousPointSystemFormValues.isValid
                    );
                }else {
                    return this.previousBingoFormValues.isValid;
                }
            } else if (
                isLottoSelected &&
                this.previousLottoFormValues !== null
            ) {
                if (point_system && isPointsSystemSelected && this.previousPointSystemFormValues !== null) {
                    return (
                        this.previousLottoFormValues.isValid &&
                        this.previousPointSystemFormValues.isValid
                    );
                }else {
                    return this.previousLottoFormValues.isValid;
                }
            } else if (
                isKenoSelected &&
                this.previousKenoFormValues !== null
            ) {
                if (point_system && isPointsSystemSelected && this.previousPointSystemFormValues !== null) {
                    return (
                        this.previousKenoFormValues.isValid &&
                        this.previousPointSystemFormValues.isValid
                    );
                }else {
                    return this.previousKenoFormValues.isValid;
                }
            }
        }

        return false;
    }

    updateStore = (formValues = this.props.settingsConfig) => {
        if (!formValues) return;

        const isSpinsSelected = formValues.game_types.indexOf("Spins") !== -1;
        const isBingoSelected = formValues.game_types.indexOf("Bingo") !== -1;
        const isLottoSelected = formValues.game_types.indexOf("Lotto") !== -1;
        const isKenoSelected = formValues.game_types.indexOf("Keno") !== -1;
        const code = this.props.editingConfiguration.subsidiary.country.code;

        const values = { ...formValues };
        let region = null;
        if (values.spins) delete values.spins;
        if (values.bingo) delete values.bingo;
        if (values.lotto) delete values.lotto;
        if (values.keno) delete values.keno;

        if (isSpinsSelected) {
            values["spins"] = this.previousSpinsFormValues
                ? { ...this.previousSpinsFormValues.values }
                : null;
        }

        if (isBingoSelected) {
            values["bingo"] = this.previousBingoFormValues
                ? { ...this.previousBingoFormValues.values }
                : null;
        }else{
            this.props.updateSpecialPrizesByBingoSettings({
                newPrizesState: [],
                actionToValidIDMap: true
            });
        }

        if (isLottoSelected) {
            values["lotto"] = this.previousLottoFormValues
                ? { ...this.previousLottoFormValues.values }
                : null;
        }

        if (isKenoSelected) {
            values["keno"] = this.previousKenoFormValues
                ? { ...this.previousKenoFormValues.values }
                : null;
        }

        if ("point_system" in values) {
            // desde 2.0.0 com separador "Points System Settings"
            values.point_system = null;
            values["regionPreset"] = null;
            values["region_preset"] = null;
            if (values["points_system"]) {
                values["point_system"] = this.previousPointSystemFormValues
                    ? {...this.previousPointSystemFormValues.values}
                    : null;
                //atribui region
                if (
                    values["point_system"] &&
                    values["point_system"]["region"] != undefined &&
                    values["point_system"]["region"] != ""
                ) {
                    region = this.props.regions.find(
                        region => region.id == values["point_system"]["region"]
                    );
                    if (region) {
                        let preset = {...region.presets[0]};
                        preset["avg_gaming_time"] = preset["avg_gaming_time"] * 1000;
                        const multiplier =
                            preset["max_prize"] / preset["max_total_bet"];
                        preset["max_prizes_per_bet_in_cents"] = preset[
                            "available_bets_in_cents"
                            ].map(bet => bet * multiplier);
                        preset["region_name"] = removeAccents(region.name);
                        preset["region_id"] = region.id;
                        values["region_preset"] = preset;
                        values["point_system"]["enable_risk_10"] = region.presets[0]['risk_10'];
                    }
                }
            }
            else{
                values.point_system = null;
                values["regionPreset"] = null;
                values["region_preset"] = null;
            }
        }
        else{
            // outras versões
            if (
                values["points_system"] == false &&
                values.hasOwnProperty("region")
            ) {
                values.region = null;
                values["regionPreset"] = null;
                values["region_preset"] = null;
            }

            if (
                values.region != undefined &&
                values.region != "" &&
                values["points_system"]
            ) {
                region = this.props.regions.find(
                    region => region.id == formValues.region
                );
                if (region) {
                    let preset = {...region.presets[0]};
                    preset["avg_gaming_time"] = preset["avg_gaming_time"] * 1000;
                    const multiplier =
                        preset["max_prize"] / preset["max_total_bet"];
                    preset["max_prizes_per_bet_in_cents"] = preset[
                        "available_bets_in_cents"
                        ].map(bet => bet * multiplier);
                    preset["region_name"] = removeAccents(region.name);
                    preset["region_id"] = region.id;
                    values["region_preset"] = preset;
                }
            }

            // max_bet = 0 e extras_count_towards_bet = false se ES e sistema de pontos ligado
            if (code === "ES"){
                values["max_bet"] = (!values["points_system"] && isBingoSelected)
                    ? values["max_bet"]
                    : 0;
                if(values["bingo"])
                    values["bingo"]["extras_count_towards_bet"] =
                        (!values["points_system"] && isBingoSelected)
                            ? values["bingo"]["extras_count_towards_bet"]
                            : false
            }
        }

        if ("panels" in values){
            values["panels"] = this.previousPanelsFormValues
                ? { ...this.previousPanelsFormValues.values }
                : null;
        }

        this.props.updateSettingsConfig({
            config: values,
            isValid: this.checkIfAllAreValid("point_system" in values)
        });
    };

    render() {
        if (this.props.editingConfigurationLoading) {
            return (
                <div className="loading" key="loading">
                    <Components.LoadingRipple width={100} height={100} />
                </div>
            );
        } else {
            const regions = this.props.regions.map(region => {
                return {
                    value: region.id,
                    label: region.name
                };
            });

            return (
                <div id="SettingsConfigurationSection">
                    <FormBoxes
                        boxes={settingsConfigBox({
                            country: this.props.basicConfig.country,
                            schema: this.props.settingsSchema,
                            session_type: this.props.settingsConfig
                                ? this.props.settingsConfig[
                                      "auto_session_enabled"
                                  ]
                                : undefined,
                            point_system:
                                this.props.settingsConfig &&
                                this.props.settingsConfig.hasOwnProperty(
                                    "points_system"
                                )
                                    ? this.props.settingsConfig["points_system"]
                                    : false,
                            form_values: this.props.settingsConfig
                                ? this.props.settingsConfig
                                : null,
                            regions: regions,
                            regionPresets: this.props.regions
                        })}
                        onChange={this.onFormChange}
                        validateOnUpdate={true}
                        initialValues={
                            this.props.settingsConfig
                                ? this.props.settingsConfig
                                : defaultValues({
                                      schema: this.props.settingsSchema,
                                      country: this.props.basicConfig.country,
                                      form_values: this.props.settingsConfig,
                                      regions: regions,
                                      regionPresets: this.props.regions
                                  })
                        }
                        isConfig={true}
                    />

                    {this.renderBingoCard()}
                    {JSON.stringify(Object.keys(this.props.settingsSchema.definitions.$spins.properties).sort()) !==  JSON.stringify(['enable_pig_boom','enable_mr_champion'].sort()) &&
                        this.renderSpinsCard()}
                    {this.renderLottoCard()}
                    {this.renderKenoCard()}
                    {'$point_system' in this.props.settingsSchema.definitions &&
                        this.props.settingsConfig &&
                        this.props.settingsConfig["points_system"] &&
                        this.renderPointsSystemPreset(regions)}
                    {this.props.settingsConfig &&
                        this.props.settingsConfig.region &&
                        this.props.settingsConfig["points_system"] &&
                        this.renderRegionPreset(this.props.settingsConfig.region)}
                    {'$point_system' in this.props.settingsSchema.definitions &&
                        this.props.settingsConfig &&
                        this.props.settingsConfig["points_system"] &&
                        this.props.settingsConfig["point_system"] &&
                        this.props.settingsConfig["point_system"]["region"] &&
                        this.renderRegionPreset(this.props.settingsConfig["point_system"]["region"])}
                    {'$panels' in this.props.settingsSchema.definitions && this.renderPanelsCard()}
                </div>
            );
        }
    }

    renderPointsSystemPreset(regions) {
        let props_point_system = this.props.editingConfiguration.settings.settings.settings.point_system;
        let state_point_system = this.state.editingConfiguration.settings.settings.settings && this.state.editingConfiguration.settings.settings.settings.point_system;
        let id = 0;
        if (props_point_system != null) id = props_point_system.region
        else if (props_point_system == null && state_point_system!=null) id = state_point_system.region

        return(
            <FormBoxes
                key={`review-point-system-${id}`}
                boxes={pointSystemConfigBox(
                    this.props.settingsSchema.definitions.$point_system,
                    regions,
                    this.props.regions,
                    this.props.settingsConfig ? this.props.settingsConfig : null
                )}
                onChange={this.onPointSystemFormChange}
                initialValues={
                    this.props.settingsConfig.point_system
                        ? this.props.settingsConfig.point_system
                        : pointSystemDefaultValues({
                              schema: this.props.settingsSchema
                          })
                }
                isConfig={true}
            />
        )
    }

    renderRegionPreset(region_id) {
        const region = this.props.regions.find(
            region => region.id == region_id
        );
        const preset = region ? region.presets[0] : {};
        return (
            <div className="region-viewer">
                <div className="form-header">Region Preset</div>
                <div className="form-container">
                    <Form
                        key={`review-preser-${region_id}`}
                        fields={regionPresetSchema()}
                        initialValues={this.formatPresetForInitial(preset)}
                        onChange={() => {}}
                    />
                </div>
            </div>
        );
    }

    formatPresetForInitial = preset => {
        const presetSchema = Object.values(regionPresetKeys);
        const country_id = this.props.editingConfiguration.subsidiary.country.id;

        let convertedPreset = {};
        Object.keys(preset).map(key => {
            const fieldSchema = presetSchema.find(field => field.key == key);
            if (fieldSchema == undefined) {
                convertedPreset[key] = preset[key];
            } else if (preset[key] == null) {
                convertedPreset[key] = "-";
            } else if (fieldSchema.hasOwnProperty("isMoney")) {
                if (Array.isArray(preset[key])) {
                    let string = preset[key].map(value => {
                        return subsidiaryDenominations[country_id](`${value / 100}`);
                    });
                    convertedPreset[key] = string.toString().replace(",", ", ");
                } else {
                    convertedPreset[key] = subsidiaryDenominations[country_id](
                        `${preset[key] / 100}`
                    );
                }
            } else if (fieldSchema.hasOwnProperty("isPercentage")) {
                convertedPreset[key] = `${preset[key]} %`;
            } else if (fieldSchema.hasOwnProperty("isTime")) {
                convertedPreset[key] = `${preset[key]} s`;
            } else if (fieldSchema.hasOwnProperty("isTimeMili")) {
                convertedPreset[key] = `${preset[key] / 1000} s`;
            } else {
                convertedPreset[key] = preset[key];
            }
        });
        return convertedPreset;
    };

    renderBingoCard() {
        return this.props.settingsConfig &&
            this.props.settingsConfig.game_types &&
            this.props.settingsConfig.game_types.indexOf("Bingo") !== -1 ? (
            <FormBoxes
                boxes={bingoConfigBox(
                    this.props.settingsSchema.definitions.$bingo,
                    this.props.basicConfig.country ? this.props.basicConfig.country : null,
                    this.props.settingsConfig && this.props.settingsConfig.hasOwnProperty("points_system")
                        ? this.props.settingsConfig["points_system"]
                        : false,
                    this.props.editingConfiguration.subsidiary.id
                )}
                onChange={this.onBingoFormChange}
                initialValues={
                    this.props.settingsConfig.bingo
                        ? this.props.settingsConfig.bingo
                        : bingoDefaultValues({
                              schema: this.props.settingsSchema
                          })
                }
                isConfig={true}
            />
        ) : null;
    }

    renderSpinsCard() {
        return this.props.settingsConfig &&
            this.props.settingsConfig.game_types &&
            this.props.settingsConfig.game_types.indexOf("Spins") !== -1 ? (
            <FormBoxes
                boxes={spinsConfigBox(
                    this.props.settingsSchema.definitions.$spins
                )}
                onChange={this.onSpinsFormChange}
                initialValues={
                    this.props.settingsConfig.spins
                        ? this.props.settingsConfig.spins
                        : spinsDefaultValues({
                              schema: this.props.settingsSchema
                          })
                }
                isConfig={true}
            />
        ) : null;
    }

    renderLottoCard() {
        return this.props.settingsConfig &&
            this.props.settingsConfig.game_types &&
            this.props.settingsConfig.game_types.indexOf("Lotto") !== -1 ? (
            <FormBoxes
                boxes={lottoConfigBox(
                    this.props.settingsSchema.definitions.$lotto,
                    this.props.basicConfig.country ? this.props.basicConfig.country : null,
                    this.props.settingsConfig && this.props.settingsConfig.hasOwnProperty("points_system")
                        ? this.props.settingsConfig["points_system"]
                        : false,
                    this.props.editingConfiguration.subsidiary.id
                )}
                onChange={this.onLottoFormChange}
                initialValues={
                    this.props.settingsConfig.lotto
                        ? this.props.settingsConfig.lotto
                        : lottoDefaultValues({
                              schema: this.props.settingsSchema
                          })
                }
                isConfig={true}
            />
        ) : null;
    }

    renderKenoCard() {
        return this.props.settingsConfig &&
            this.props.settingsConfig.game_types &&
            this.props.settingsConfig.game_types.indexOf("Keno") !== -1 ? (
            <FormBoxes
                boxes={kenoConfigBox(
                    this.props.settingsSchema.definitions.$keno,
                    this.props.basicConfig.country ? this.props.basicConfig.country : null,
                    this.props.settingsConfig && this.props.settingsConfig.hasOwnProperty("points_system")
                        ? this.props.settingsConfig["points_system"]
                        : false,
                    this.props.editingConfiguration.subsidiary.id
                )}
                onChange={this.onKenoFormChange}
                initialValues={
                    this.props.settingsConfig.keno
                        ? this.props.settingsConfig.keno
                        : kenoDefaultValues({
                              schema: this.props.settingsSchema
                          })
                }
                isConfig={true}
            />
        ) : null;
    }

    renderPanelsCard() {
        return this.props.settingsConfig && (
            <FormBoxes
                boxes={panelsConfigBox(
                    this.props.settingsSchema.definitions.$panels
                )}
                onChange={this.onPanelFormChange}
                initialValues={
                    this.props.settingsConfig.panels
                        ? this.props.settingsConfig.panels
                        : panelsDefaultValues({
                            schema: this.props.settingsSchema
                        })
                }
                isConfig={true}
            />
        );
    }
}

const mapDispatchToProps = {
    updateSettingsConfig: ConfigurationsActionCreators.updateSettingsConfig,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited,
    updateGroupByGameType: ConfigurationsActionCreators.updateGroupByGameType,
    updateSpecialPrizesByBingoSettings: ConfigurationsActionCreators.updateSpecialPrizesByBingoSettings
};

const mapStateToProps = state => ({
    settingsSchema: configurationsStoreSelectors.settingsSchema(state),
    schemaLoading: configurationsStoreSelectors.schemaLoading(state),
    editingConfiguration:
        configurationsStoreSelectors.editingConfiguration(state),
    gameInstances: configurationsStoreSelectors.gameInstances(state),
    gameGroups: configurationsStoreSelectors.gameGroups(state),
    selectedGameGroups: configurationsStoreSelectors.selectedGameGroups(state),
    settingsConfig: configurationsStoreSelectors.settingsConfig(state),
    basicConfig: configurationsStoreSelectors.basicConfig(state),
    editingConfigurationLoading:
        configurationsStoreSelectors.editingConfigurationLoading(state),
    regions: configurationsStoreSelectors.regions(state),
    configFormValid: configurationsStoreSelectors.configFormValid(state),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsConfigurationSection);
